<div class="grid">
  <ng-content></ng-content>
  @if (infoText()) {
    <app-link iconClass="dx-icon-info small" (onClick)="toggleInfoBox()"></app-link>
  }
  <div class="info-box-outer" [class.info-box-outer--hidden]="!infoBoxVisible()" [attr.aria-hidden]="!infoBoxVisible()">
    <div class="info-box">
      <app-link iconClass="dx-icon-remove" (onClick)="toggleInfoBox()"></app-link>
      <p>{{infoText()}}</p>
    </div>
  </div>
</div>
